import React from 'react';
import type { DropdownOptionProps } from 'wix-ui-tpa/cssVars';
import { LocationSmall } from '@wix/wix-ui-icons-common';
import { useStyles } from '@wix/tpa-settings/react';
import { stylesParams } from 'root/components/Menus/stylesParams';
import { useLocationsBi } from './Locations.bi';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import type { LocationsProps } from './Locations';

export const useLocationsLogic = ({
  locations,
  currentLocation,
  setCurrentLocation,
  menus,
  navigateTo,
  currentUrl,
  setActiveTab,
}: LocationsProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const locationsDropdownStyle = styles.get(stylesParams.locationsDropdownStyle);
  const { reportLocationNavigationClick } = useLocationsBi();
  const { experiments } = useExperiments();
  const isDropdownBottomExperimentEnabled = experiments.enabled('specs.restaurants.menusOoiDropdownBottom');
  const isLocationURLQueryParamExperimentEnabled = experiments.enabled('specs.restaurants.locationURLQueryParam');
  const dropdownOptions: DropdownOptionProps[] = Object.entries(locations).map(
    ([id, value]): DropdownOptionProps => ({
      id,
      value,
      isSelectable: true,
      icon: <LocationSmall />,
    })
  );

  const onClickDropdownOption = (locationId: string, locationName: string) => {
    setCurrentLocation(locationId);
    setActiveTab(0);
    reportLocationNavigationClick({
      locationId,
      locationName,
      numberOfLocations: dropdownOptions.length,
      previousLocationId: currentLocation,
      previousLocationName: locations[currentLocation],
    });

    if (isLocationURLQueryParamExperimentEnabled && navigateTo && currentUrl) {
      const url = new URL(currentUrl);
      url.searchParams.set('location', locationName);

      navigateTo({
        currentUrl: url.toString(),
        locationName,
        isFirst: true,
      });
    }
  };

  return {
    dropdownOptions,
    locationsDropdownStyle,
    onClickDropdownOption,
    dropdowmPlacement: isDropdownBottomExperimentEnabled ? 'bottom' : undefined,
    dropdownFlip: isDropdownBottomExperimentEnabled ? false : undefined,
    t,
  };
};
